import pluralize from "pluralize"

import { faIcon } from "@utils/faIcon"

import { EmptyState } from "@molecules"

import useTable from "@organisms/Table/Table.context"
import styles from "@organisms/Table/TableEdgeStates/TableEdgeStates.module.scss"

import { TableHiddenByScheduleHorizonStateProps } from "./TableHiddenByScheduleHorizonState.types"

export default function TableHiddenByScheduleHorizonState(props: TableHiddenByScheduleHorizonStateProps) {
    const { children } = props

    const { objectName, hiddenByScheduleHorizonCount, setIsViewMenuOpen } = useTable()

    const objectLabel = objectName.toLowerCase()

    return (
        <>
            {children}
            <div className={styles.base}>
                <EmptyState
                    variant="default"
                    icon={faIcon({ name: "calendar", style: "regular" })}
                    title={`No ${pluralize(objectLabel)} within the schedule horizon`}
                    supportText={
                        <>
                            <span className={styles.emphasis}>
                                {hiddenByScheduleHorizonCount} {pluralize(objectLabel, hiddenByScheduleHorizonCount)}
                            </span>{" "}
                            hidden by schedule horizon
                        </>
                    }
                    primaryCTA={{
                        children: "Show settings",
                        onClick: () => setIsViewMenuOpen(true),
                        noDebounce: true,
                    }}
                />
            </div>
        </>
    )
}
